// Consentimento de cookies (Google Consent Mode v2)
// O padrão "negado" é definido no layout (script beforeInteractive), antes de o GTM carregar.

export const CONSENT_STORAGE_KEY = 'cookie-consent'
export const OPEN_BANNER_EVENT = 'open-cookie-banner'

export type ConsentChoice = 'granted' | 'denied'

type DataLayerWindow = Window & { dataLayer?: unknown[] }

/** O GTM espera receber o objeto `arguments` (como faz o gtag), não um array. */
function gtag(..._args: unknown[]) {
  const w = window as DataLayerWindow
  w.dataLayer = w.dataLayer || []
  // eslint-disable-next-line prefer-rest-params
  w.dataLayer.push(arguments)
}

export function getStoredConsent(): ConsentChoice | null {
  try {
    const value = localStorage.getItem(CONSENT_STORAGE_KEY)
    return value === 'granted' || value === 'denied' ? value : null
  } catch {
    return null
  }
}

/** Guarda a escolha e avisa o Google. Só a medição de uso (analytics) depende do consentimento. */
export function saveConsent(choice: ConsentChoice) {
  try {
    localStorage.setItem(CONSENT_STORAGE_KEY, choice)
  } catch {}
  gtag('consent', 'update', { analytics_storage: choice })
}
